<template>
  <div class="reserveTime">
    <div>
      {{ desiredDate.PlanDate }} {{ desiredDate.time }}
    </div>
    <div class="time_tit">
      <div
        class="wk"
        @click="changeWeek('previous')"
      ><i class="el-icon-arrow-left" />上周</div>
      <div
        class="wk"
        @click="changeWeek('next')"
      >下周<i class="el-icon-arrow-right" /></div>
    </div>
    <div
      v-if="isData"
      style="width: 100%;text-align: center; font-size: 12px"
    >
      <el-row v-if="tabLoading">
        <el-col :span="4">
          <div class="tabH">体检中心</div>
          <div
            v-for="(label, index) in tableL"
            :key="index"
          >
            <div class="tabB">{{ label }}</div>
          </div>
        </el-col>
        <el-col
          v-for="(item, i) in tableH"
          :key="i"
          :span="3"
        >
          <div class="tabH">
            {{ item }}
          </div>
          <div
            v-for="(label, index) in arrOne"
            :key="index"
            class="tabC"
          >
            <div
              v-if="label.PlanDate === item"
              :class="label._ReStatusDispaly === 1 ? 'tabBC' : 'tabB'"
              @click="appointmentRegister(label)"
            >
              {{ label.CanReCount }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div
      v-else
      style="width: 100%;text-align: center; font-size: 12px"
    >暂无排班资源</div>
  </div>
</template>

<script>
import mixins from "./mixins";
import menZhenService from "@/apis/menZhen/index.js";
import moment from "moment";
import { Message } from "element-ui";
import { mapGetters } from "vuex";
import bookingService from "@/apis/booking";

export default {
  name: "reserveTime",
  mixins: [mixins],
  computed: {
    ...mapGetters(["formProductInfo"]),
  },
  watch: {
    formProductInfo: {
      handler(newVal) {
        console.log(newVal);
        if (newVal.product_id) this.bookQuery();
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      searchDate: [
        moment().day(1).format("YYYY-MM-DD"),
        moment().day(7).format("YYYY-MM-DD"),
      ],
      tableH: [],
      tableL: [],
      tabLoading: true,
      isData: false,
      desiredDate: {},
      arrOne: [],
    };
  },
  created() {
    this.bookQuery();
  },
  methods: {
    changeWeek(type) {
      // const Repeater1_txtYichang_0 = document.querySelector(
      //   "#Repeater1_txtYichang_0"
      // );
      // Repeater1_txtYichang_0.addEventListener("input", () => {
      //   Repeater1_txtYichang_0.style.height = `${Repeater1_txtYichang_0.scrollHeight}px`;
      // });
      const { searchDate } = this;
      if (type === "next") {
        this.searchDate = [
          moment(searchDate[0]).add(7, "days").format("YYYY-MM-DD"),
          moment(searchDate[1]).add(7, "days").format("YYYY-MM-DD"),
        ];
      } else {
        this.searchDate = [
          moment(searchDate[0]).subtract(7, "days").format("YYYY-MM-DD"),
          moment(searchDate[1]).subtract(7, "days").format("YYYY-MM-DD"),
        ];
      }
      this.bookQuery();
    },
    appointmentRegister(timeItem) {
      console.log(timeItem);
      if (timeItem._ReStatusDispaly === 0) {
        Message.error("不可预约");
        return;
      } else if (timeItem.CanReCount === "0") {
        Message.error("不可预约");
        return;
      }
      this.desiredDate = timeItem;
      this.answerChange(timeItem);
    },
    async bookQuery() {
      const { searchDate, question, formProductInfo } = this;
      const params = {
        itemId: question.field_id === "booking_time" ? "5473" : "5466",
        beginDate: searchDate[0],
        endDate: searchDate[1],
      };
      this.tabLoading = true;
      let res = [];
      // if (question.field_id !== "tj_booking_time") {
      if (question.field_id) {
        res = await menZhenService.bookQuery(params);
      } else if (formProductInfo.product_id) {
        const idlist = [];
        if (formProductInfo.neijingItemID) {
          idlist.push("13");
        }
        if (formProductInfo.waiSongItemID) {
          idlist.push("46");
        }
        const hisPlanParams = {
          itemId: formProductInfo.his_package_id == 0 ? "" : "5466",
          idlist: idlist.join(","),
          bDate: searchDate[0],
          eDate: searchDate[1],
          packageId: formProductInfo.his_package_id,
        };
        res = await bookingService.hisPlanSearch(hisPlanParams);
        res.forEach((item) => {
          item.CanReCount = item["预约号数"];
          item._ReStatusDispaly = item["预约号数"];
          item.PlanDate = moment(item["预约日期"]).format("MM-DD");
          item.appointDateFomat = item["预约日期"];
          item.PlanId = item["内镜人次ID"];
          item.itemId = 5473;
          item.BeginTime = item["开始时间"];
          item.EndTime = item["截止时间"];
        });
      }
      console.log(res);
      const arr = [];
      const newArr = [];
      if (res.length === 0) {
        this.isData = false; // 暂无排班资源
      } else {
        this.isData = true;
        res.forEach((item) => {
          const obj = {};
          arr.push(item.PlanDate);
          obj.CanReCount = item.CanReCount;
          obj._ReStatusDispaly = item._ReStatusDispaly;
          obj.PlanDate = item.PlanDate;
          obj.appointDateFomat = item.appointDateFomat;
          obj.PlanId = item.PlanId;
          obj.itemId = item.itemId;
          obj.time = item.BeginTime + "-" + item.EndTime;
          newArr.push(obj);
        });
        // 获取表格头
        this.tableH = [...new Set(arr)];
        // 获取时间段
        const tableL = [];
        newArr.forEach((label) => {
          tableL.push(label.time);
        });
        this.tableL = [...new Set(tableL)];

        // 获取内容
        const arrOne = [];
        this.tableH.forEach((date) => {
          this.tableL.forEach((time) => {
            if (
              !newArr.some((item) => {
                if (item.PlanDate === date && item.time === time) {
                  arrOne.push(item);
                  return true;
                }
                return false;
              })
            ) {
              arrOne.push({
                _ReStatusDispaly: 0,
                PlanDate: date,
                CanReCount: 0,
              });
            }
          });
        });
        this.arrOne = arrOne;
      }
    },
    change() {
      this.answerChange(this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.content_workers {
  margin-bottom: 20px;
}
.time_tit {
  display: flex;
  justify-content: space-between;
  text-align: center;
  height: 40px;
  line-height: 40px;
  background-color: rgb(242, 242, 242);
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}
.search_sty {
  margin-top: 20px;
}
.buton_ser {
  margin: 20px 0 20px 40px;
}
.pepMess {
  height: 50px;
  width: 80vw;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  line-height: 50px;
  background: #f2f2f2;
  border-radius: 11px;
  padding: 0 20px 0 80px;
  margin: 10px 0;
  font-size: 12px;
  span {
    margin-right: 10px;
  }
}
.pepMess::-webkit-scrollbar {
  width: 14px;
  height: 5px;
  background: fff;
}
.pepMess::-webkit-scrollbar-thumb {
  border-radius: 1px;
  // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #ccc;
}
.pep {
  height: 50px;
  width: 80vw;
  line-height: 50px;
  background: #f2f2f2;
  border-radius: 11px;
  padding: 0 20px;
  margin: 10px 0;
  font-size: 12px;
  span {
    margin-right: 10px;
  }
}
.tabH {
  background: rgba(58, 142, 230, 0.2);
  height: 50px;
  line-height: 50px;
  border: 1px solid #ebeef5;
}
.tabB {
  height: 40px;
  border: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.tabBC {
  height: 40px;
  line-height: 40px;
  border: 1px solid #ebeef5;
  color: rgb(58, 142, 230);
  cursor: pointer;
}
.mes {
  margin-bottom: 20px;
}
.content_workers .content_workers.time {
  width: 300px;
}
.wk {
  cursor: pointer;
}
</style>